import { DraggableDialogPosition } from './DraggableDialogPosition';
import { DraggableDialogContent } from './DraggableDialogContent';
import { DraggableDialogToolbar } from './DraggableDialogToolbar';

const DraggableDialog = DraggableDialogPosition;
DraggableDialog.Content = DraggableDialogContent;
DraggableDialog.Toolbar = DraggableDialogToolbar;

export { DraggableDialog };
